import { DropdownPaginated } from 'components/commons';
import React, { useCallback, useEffect, useState } from 'react';
import { useApi } from 'hooks';
import { getAccounts } from 'apis/account.api';

const SelectAccount = ({ tabIndex, placeholder = '', categoryId = null, level = null, isPostable, ...props }) => {
  const {
    request,
    loading
    // result = { accounts: [], count: 0 }
  } = useApi({
    api: getAccounts,
    pageError: true
  });

  const [allAccounts, setAllAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = useCallback(
    async (params = {}) => {
      if (categoryId) params.categoryId = categoryId;
      if (isPostable) params.isPostable = isPostable;
      if (level) params.level = parseInt(level);

      const res = await request({
        perPage: 10000, // large enough to cover all accounts
        orderBy: 'code',
        order: 'asc',
        status: 'active',
        ...params
      });

      if (res?.accounts) {
        setAllAccounts(res.accounts);
        setIsLoading(false);
      }

      return res;
    },
    [categoryId, isPostable, level, request]
  );

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, isPostable, level]);

  return (
    <DropdownPaginated
      {...props}
      request={async ({ search }) => {
        const filtered = allAccounts.filter((acc) => {
          const codeName = `${acc.code} - ${acc.name}`.toLowerCase();
          return codeName.includes((search || '').toLowerCase());
        });
        return {
          accounts: filtered,
          count: filtered.length
        };
      }}
      total={allAccounts.length}
      loading={loading && isLoading}
      formatRequest={(result) => {
        const { accounts = [] } = result || {};
        return accounts.map((d) => ({
          label: `${d.code} - ${d.name}`,
          value: d.accountId,
          isCash: d.isCash,
          code: d.code,
          accountName: d.name
        }));
      }}
      placeholder={placeholder}
      tabIndex={tabIndex}
    />
  );
};

export default SelectAccount;
